import { isAxiosError } from 'axios';

/**
 * Per-field messages from a rejected save, or null when the response carries none.
 * Serializer errors come back as `{field: [...]}`; the model-validated endpoints
 * wrap the same shape in `{errors: {...}}`.
 */
export const apiFieldErrors = (error: unknown): Record<string, string[]> | null => {
  if (!isAxiosError(error)) return null;
  const data: unknown = error.response?.data;
  if (!data || typeof data !== 'object') return null;
  const body = 'errors' in data ? (data as { errors: unknown }).errors : data;
  if (!body || typeof body !== 'object' || Array.isArray(body)) return null;

  const fields = Object.entries(body).filter(
    (entry): entry is [string, string[]] =>
      Array.isArray(entry[1]) && entry[1].every((m) => typeof m === 'string')
  );
  return fields.length ? Object.fromEntries(fields) : null;
};
